import React from "react"
import { Grid2 } from "@mui/material"
import { Text } from "@/components/Text"

import { themeColors } from "@/styles"

import { InputErrorTextProps } from "@/components/Input/protocols"

export const ErrorText = ({
	errorText
}: InputErrorTextProps) => {
	if (!errorText) {
		return null
	}

	return (
		<Grid2 container>
			<Text.Body type="small2" color={themeColors.getTextErrorColor()}>
				{errorText}
			</Text.Body>
		</Grid2>
	)
}
